import { useState, useEffect } from "react";
import {
  Grid,
  Button,
  Typography,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";

const AnswerMap = ({ questionData, handleChange, baseQuestion }) => {
  const [choiceMapping, setChoiceMapping] = useState({});

  useEffect(() => {
    if (questionData?.matchingAnswer) {
      setChoiceMapping(JSON.parse(questionData.matchingAnswer));
    }
  }, []);

  const handleChoiceChange = (index, field, value) => {
    const updatedChoices = [...questionData.choices];
    updatedChoices[index][field] = value;
    // setChoices(updatedChoices);
    handleChange("choices", updatedChoices);
  };

  const handleMappingChange = (choice, value) => {
    const updatedMapping = {
      ...choiceMapping,
      [choice]: value,
    };
    setChoiceMapping(updatedMapping);
    handleChange("matchingAnswer", JSON.stringify(updatedMapping)); // Update the matching answer
  };

  if (
    questionData?.questionType === "multipleChoice" &&
    questionData?.matchingCriteria === "multiple"
  ) {
    return (
      <Grid
        item
        xs={12}
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 20,
          border: "solid 1px black",
          borderRadius: 5,
          margin: 20,
          padding: 20,
        }}
      >
        <Typography variant="h6" sx={{ marginTop: 2 }}>
          Map Matching Answers
        </Typography>
        {questionData?.choices.map((choice, c) => (
          <Grid container spacing={2} alignItems="center" key={c}>
            <Grid item xs={5}>
              <Typography align="center">Answering {choice.label}</Typography>
            </Grid>
            {/* <Grid item xs={1}>
            <ArrowForwardIcon />
          </Grid> */}
            <Grid item xs={2}>
              <FormControl fullWidth>
                <InputLabel>Map to</InputLabel>
                <Select
                  disabled={baseQuestion}
                  multiple={questionData.matchingCriteria === "multiple"}
                  value={
                    Array.isArray(choiceMapping[choice.value])
                      ? choiceMapping[choice.value].filter(Boolean) // Filter out falsy values like empty strings
                      : choiceMapping[choice.value] &&
                        choiceMapping[choice.value] !== ""
                      ? [choiceMapping[choice.value]] // Include only non-empty strings
                      : []
                  }
                  onChange={(e) =>
                    handleMappingChange(choice.value, e.target.value)
                  }
                  renderValue={(selected) =>
                    Array.isArray(selected)
                      ? selected.filter(Boolean).join(", ") // Filter out falsy values and join for display
                      : selected
                  }
                >
                  {questionData?.choices.map((choice) => (
                    <MenuItem key={choice.value} value={choice.value}>
                      {choice.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={5}>
              <Typography> to "{questionData.question}"</Typography>
            </Grid>
          </Grid>
        ))}
      </Grid>
    );
  }

  return <></>;
};

export default AnswerMap;
